import React, { useEffect, useState } from "react";
import { Table, Modal, Badge, Card } from "react-bootstrap";
import axios from "axios";
import { FaMapMarkerAlt, FaCubes } from "react-icons/fa";

function BasicExample() {
  const [sortedClientiData, setSortedClientiData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: "valore", direction: "descending" });
  const [showModal, setShowModal] = useState(false);
  const [selectedCliente, setSelectedCliente] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("mancata_vendita_dashboard.json");
        const clientiData = res.data?.TP?.localita || [];

        const transformedData = clientiData.reduce((acc, item) => {
          const id = item.id_cliente;
          const origine = item.origine || item["Tipo Documento"] || "web";
          const key = `${id}-${origine}`;

          const parseVal = (v) => parseFloat(String(v ?? "0").replace(",", ".")) || 0;

          const valoreTotale     = parseVal(item.Valore);
          const valoreLastMinute = parseVal(item.Valore_Last_Minute);
          const valoreNormale    = parseVal(item.Valore_Normale);

          if (!acc[key]) {
            acc[key] = {
              id_cliente: id,
              cliente:   item.clienti,
              localita:  item.regione || item.nazione || item.paese || "—",
              origine,
              valore:   0,
              express:  0,
              regular:  0,
              numero:   0,
              dettagli: {}, // Modificato in oggetto per raggruppare per Marchio
            };
          }

          acc[key].valore  += valoreTotale;
          acc[key].express += valoreLastMinute;
          acc[key].regular += valoreNormale;
          acc[key].numero  += Number(item.numero_doc || 0);

          // Raggruppamento e somma dei valori per Marchio (item.descrizione)
          const marchio = item.descrizione || "Generico";
          if (!acc[key].dettagli[marchio]) {
            acc[key].dettagli[marchio] = { valore: 0, note: [] };
          }
          acc[key].dettagli[marchio].valore += valoreTotale;
          if (item.note_agg) {
            acc[key].dettagli[marchio].note.push(item.note_agg);
          }

          return acc;
        }, {});

        // Conversione dell'oggetto dettagli in array ordinato per valore descrescente
        Object.values(transformedData).forEach((cliente) => {
          cliente.dettagli = Object.entries(cliente.dettagli)
            .map(([marchio, info]) => ({
              descrizione: marchio,
              valore: info.valore,
              note: info.note.length > 0 ? info.note.join(" | ") : null,
            }))
            .sort((a, b) => b.valore - a.valore);
        });

        setSortedClientiData(
          sortArray(Object.values(transformedData), sortConfig.key, sortConfig.direction)
        );
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, [sortConfig]);

  const sortArray = (array, key, direction) =>
    [...array].sort((a, b) => {
      const av = a[key] ?? 0;
      const bv = b[key] ?? 0;
      if (typeof av === "number")
        return direction === "ascending" ? av - bv : bv - av;
      return direction === "ascending"
        ? String(av).localeCompare(String(bv))
        : String(bv).localeCompare(String(av));
    });

  const handleSort = (key) =>
    setSortConfig({
      key,
      direction:
        sortConfig.key === key && sortConfig.direction === "ascending"
          ? "descending"
          : "ascending",
    });

  const formatToEuro = (amount) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);

  const SortIcon = ({ colKey }) => {
    if (sortConfig.key !== colKey) return null;
    return sortConfig.direction === "ascending" ? " ↑" : " ↓";
  };

  return (
    <>
      <Card
        className="card ombra ordini-ora card-home hover-effect border-0"
        style={{ borderRadius: "15px", padding: "1.2rem", paddingBottom: "0" }}
      >
        <div
          className="no-scrollbar"
          style={{ width: "100%", height: 300, overflowY: "auto", overflowX: "auto", position: "relative" }}
        >
          <Table
            hover
            className="mb-0 custom-table"
            style={{ fontSize: "0.75rem", width: "100%", minWidth: "700px", margin: 0, borderCollapse: "separate" }}
          >
            <thead className="sticky-top bg-white" style={{ zIndex: 10 }}>
              <tr className="importoCliente small importoCliente" style={{ borderBottom: "2px solid #f1f1f1" }}>
                <th style={{ width: "25%" }} className="ps-4 py-3 border-0 importoCliente importoCliente">CLIENTE</th>
                <th style={{ width: "15%" }} className="py-3 border-0 cursor-pointer importoCliente importoCliente" onClick={() => handleSort("localita")}>
                  LOCALITÀ<SortIcon colKey="localita" />
                </th>
                <th className="py-3 border-0 text-end cursor-pointer importoCliente" style={{  width: "15%"  }} onClick={() => handleSort("valore")}>
                  VALORE<SortIcon colKey="valore" />
                </th>
                <th style={{ width: "15%" }} className="py-3 border-0 text-end text-danger cursor-pointer importoCliente" onClick={() => handleSort("express")}>
                  LAST MINUTE<SortIcon colKey="express" />
                </th>
                <th style={{ width: "12%" }} className="py-3 border-0 text-end text-secondary cursor-pointer importoCliente" onClick={() => handleSort("regular")}>
                  REGULAR<SortIcon colKey="regular" />
                </th>
                <th style={{ width: "8%" }} className="py-3 border-0 text-center importoCliente importoCliente">ORDINI</th>
                <th style={{ width: "10%" }} className="py-3 border-0 text-center pe-4 importoCliente importoCliente">ORIGINE</th>
              </tr>
            </thead>
            <tbody>
              {sortedClientiData.map((item, index) => (
                <tr
                  key={index}
                  onClick={() => { setSelectedCliente(item); setShowModal(true); }}
                  className="cursor-pointer align-middle"
                >
                  <td className="ps-4 fw-bold importoCliente importoCliente truncate-cell">{item.cliente}</td>
                  <td className="importoCliente importoCliente truncate-cell" style={{ fontSize: "0.7rem" }}>{item.localita}</td>
                  <td className="text-end fw-bold importoCliente no-wrap" >{formatToEuro(item.valore)}</td>
                  <td className="text-end text-danger fw-bold importoCliente no-wrap">{formatToEuro(item.express)}</td>
                  <td className="text-end text-secondary importoCliente no-wrap" style={{ fontSize: "0.65rem" }}>{formatToEuro(item.regular)}</td>
                  <td className="text-center importoCliente importoCliente"><span>{item.numero}</span></td>
                  <td className="text-center importoCliente importoCliente pe-4">
                    <Badge
                      pill
                      className={item.origine === "web" ? "bg-danger-subtle text-danger" : "bg-secondary-subtle text-secondary"}
                      style={{ fontSize: "0.6rem"} }
                    >
                      {item.origine.toUpperCase()}
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        <style>{`
          .custom-table { width: 100% !important; margin: 0 !important; }
          .truncate-cell { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 150px; }
          .no-wrap { white-space: nowrap; }
          .cursor-pointer { cursor: pointer; }
          .fw-800 { font-weight: 800; }
          tbody tr:hover { background-color: #fbfbfb !important; }
          .sticky-top { top: -1px; background: white !important; box-shadow: 0 2px 2px -1px rgba(0,0,0,0.05); }
          ::-webkit-scrollbar { height: 6px; width: 4px; }
          ::-webkit-scrollbar-thumb { background: #e0e0e0; border-radius: 10px; }
          .bg-danger-subtle { background-color: rgba(220, 53, 69, 0.1); }
          .bg-secondary-subtle { background-color: rgba(108, 117, 125, 0.1); }
        `}</style>
      </Card>

      {/* MODAL DETTAGLIO */}
      <Modal
        show={showModal}
        className="modale-dettaglio-root"
        dialogClassName="modale-dettaglio-dialog"
        onHide={() => setShowModal(false)}
        centered
        size="sm"
        backdrop={true}
      >
        <Modal.Header closeButton className="border-0 importoCliente text-white pb-3 pt-4 px-4">
          <Modal.Title className="d-flex align-items-center w-100">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center me-3 shadow-sm"
              style={{ 
                width: "45px", 
                height: "45px", 
                backgroundColor: "rgba(241,111,36,0.1)", 
                border: "1px solid rgba(241,111,36,0.3)" 
              }}
            >
              <FaCubes size={22} style={{ color: "rgba(241,111,36,1)" }} />
            </div>
            <div className="overflow-hidden">
              <div style={{ fontSize: "1.25rem", fontWeight: "800", letterSpacing: "-0.5px", lineHeight: "1.2", color: "#fff" }}>
                {selectedCliente?.cliente}
              </div>
              <div className="text-muted fw-medium d-flex align-items-center mt-1" style={{ fontSize: "0.85rem" }}>
                <FaMapMarkerAlt className="me-1 text-danger" />
                <span className="importoCliente">{selectedCliente?.localita}</span>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="importoCliente px-4 pb-4 pt-0">
          <div className="mb-4 d-flex gap-2 flex-wrap">
            <Badge bg="secondary" className="bg-opacity-25 importoCliente fw-normal border border-secondary" style={{ fontSize: "0.7rem", padding: "5px 10px" }}>
              ID: {selectedCliente?.id_cliente}
            </Badge>
            <Badge pill className="bg-info bg-opacity-10 text-info border border-info" style={{ fontSize: "0.7rem", padding: "5px 10px" }}>
              {selectedCliente?.origine?.toUpperCase()}
            </Badge>
            <Badge pill className="bg-danger bg-opacity-10 text-danger border border-danger" style={{ fontSize: "0.7rem", padding: "5px 10px" }}>
              LM: {formatToEuro(selectedCliente?.express)}
            </Badge>
            <Badge pill className="bg-secondary bg-opacity-10 text-secondary border border-secondary" style={{ fontSize: "0.7rem", padding: "5px 10px" }}>
              REG: {formatToEuro(selectedCliente?.regular)}
            </Badge>
          </div>

          <div className="d-flex justify-content-center">
            <div className="rounded-3 border-0 overflow-hidden shadow-sm" style={{ width: "100%", backgroundColor: "#1a1d20" }}>
              <Table hover className="mb-0" style={{ color: "#eee" }}>
                <thead>
                  <tr style={{ backgroundColor: "rgba(255,255,255,0.03)" }}>
                    <th className="ps-3 py-3 importoCliente importoCliente border-0 text-uppercase" style={{ fontSize: "0.7rem", color: "#888", letterSpacing: "1px" }}>Brand / Nota</th>
                    <th className="text-end pe-3 importoCliente importoCliente py-3 border-0 text-uppercase" style={{ fontSize: "0.7rem", color: "#888", letterSpacing: "1px" }}>Valore</th>
                  </tr>
                </thead>
                <tbody style={{ borderTop: "1px solid #333" }}>
                  {selectedCliente?.dettagli.map((d, i) => (
                    <tr key={i} className="align-middle" style={{ borderBottom: "1px solid #2a2d30" }}>
                      <td className="ps-3 py-3 importoCliente importoCliente fw-medium border-0" style={{ fontSize: "0.95rem" }}>
                        {d.descrizione}
                      </td>
                      <td className="text-end text-dark pe-3 importoCliente importoCliente py-3 fw-bold border-0" style={{ color: "#fff", fontSize: "1rem" }}>
                        {formatToEuro(d.valore)}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr style={{ backgroundColor: "rgba(241,111,36,0.05)" }}>
                    <td className="ps-3 py-3 importoCliente importoCliente border-0 fw-bold" style={{ fontSize: "0.9rem", color: "#ffffff" }}>TOTALE</td>
                    <td className="text-end pe-3 importoCliente py-3 border-0 fw-800" style={{ fontSize: "1.1rem", color: "rgba(241,111,36,1)" }}>
                      {formatToEuro(selectedCliente?.valore)}
                    </td>
                  </tr>
                </tfoot>
              </Table>
            </div>
          </div>
        </Modal.Body>

        <style>{`
          .modale-dettaglio-root .btn-close {
              filter: invert(1) grayscale(100%) brightness(200%);
              opacity: 0.8;
          }
          .fw-800 { font-weight: 800; }
        `}</style>
      </Modal>
    </>
  );
}

export default BasicExample;